import { useCallback, useEffect, useRef } from 'react';

import { ArticleModelLifeCycleCode } from 'api/models';
import { ppmIconSmall } from 'app/assets/ppm/16/ppmIconSmall';
import { ppmIconLarge } from 'app/assets/ppm/32/ppmIconLarge';

interface ArticleLifeCycleIconProps {
    lifeCycleCode: ArticleModelLifeCycleCode | undefined;
}

export const ArticleLifeCycleIcon = ({ lifeCycleCode }: ArticleLifeCycleIconProps) => {
    const imgRef = useRef<HTMLImageElement | null>(null);

    const updateIcon = useCallback(() => {
        if (!imgRef.current) {
            return;
        }

        const dpr = window.devicePixelRatio || 1;
        imgRef.current.src = dpr > 1 ? ppmIconLarge[lifeCycleCode ?? 'U'] : ppmIconSmall[lifeCycleCode ?? 'U'];
    }, [lifeCycleCode]);

    useEffect(() => {
        window.addEventListener('resize', updateIcon);
        return () => window.removeEventListener('resize', updateIcon);
    }, [lifeCycleCode, updateIcon]);

    const handleIconRef = (img: HTMLImageElement | null) => {
        imgRef.current = img;
        updateIcon();
    };

    return (
        <img ref={handleIconRef} alt="Icon" height={'16px'} src={ppmIconSmall[lifeCycleCode ?? 'U']} width={'16px'} />
    );
};
